const crypto = require("crypto");

const algorithm = "aes-256-ctr";

// CRYPTO_PASSWORD is loaded into process.env by secretsLoader.js on the server.
// On the client (browser), process.env is not available at runtime, so encrypt/decrypt
// become identity functions — phone numbers are transmitted over HTTPS which provides
// transport-layer confidentiality. The AES layer was removed from publicRuntimeConfig
// as part of CSPM-4003 remediation (key was exposed to unauthenticated callers).
const getPassword = () => (typeof process !== "undefined" && process.env && process.env.CRYPTO_PASSWORD) || null;

const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(character) {
    let randomValue = (Math.random() * 16) | 0,
      value = character == "x" ? randomValue : (randomValue & 0x3) | 0x8;
    return value.toString(16);
  });
};

const encrypt = (text) => {
  const password = getPassword();
  if (!password) return text;
  var cipher = crypto.createCipher(algorithm, password);
  var crypted = cipher.update(text, "utf8", "hex");
  crypted += cipher.final("hex");
  return crypted;
};

const decrypt = (text) => {
  const password = getPassword();
  if (!password) return text;
  var decipher = crypto.createDecipher(algorithm, password);
  var dec = decipher.update(text, "hex", "utf8");
  dec += decipher.final("utf8");
  return dec;
};

module.exports = {
  uuidv4,
  encrypt,
  decrypt,
};
